(() => {
  const editable = (node) => {
    const element = node instanceof Element ? node : node?.parentElement;
    return Boolean(element?.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])'));
  };
  document.addEventListener('selectstart', (event) => {
    if (!editable(event.target)) event.preventDefault();
  });
  document.addEventListener('copy', (event) => {
    if (!editable(event.target) && !editable(document.activeElement)) event.preventDefault();
  });
})();
